/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Reject_ErrorInputs */

const en_applicants_bulk_reject_error = /** @type {(inputs: Applicants_Bulk_Reject_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reject applications`)
};

const de_applicants_bulk_reject_error = /** @type {(inputs: Applicants_Bulk_Reject_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen konnten nicht abgelehnt werden`)
};

/**
* | output |
* | --- |
* | "Failed to reject applications" |
*
* @param {Applicants_Bulk_Reject_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_reject_error = /** @type {((inputs?: Applicants_Bulk_Reject_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Reject_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_reject_error(inputs)
	return en_applicants_bulk_reject_error(inputs)
});